// extracted by mini-css-extract-plugin
export default {"row":"styles_row__Ksd+K","valid":"styles_valid__vF9Ke","not-valid":"styles_not-valid__WkzXg","bold":"styles_bold__6izBR"};